<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <PreviewControl
      :current-page="page"
      :number-of-pages="numPages"
      :file-name="fileName"
      :mail-from="mailFrom"
      :mail-date="mailDate"
      :mail-subject="mailSubject"
      @page-change="page = $event"
      @rotate="rotate += 1"
      @refresh-canvas-size="refreshCanvasSize += 1"
    />
    <Preview
      :page="page"
      :url="file"
      :rotate="rotate"
      :refresh-canvas-size="refreshCanvasSize"
      @num-pages="numPages = $event"
      @image-data="$emit('image-data', $event)"
    >
      <template #overlay>
        <slot name="fields"></slot>
      </template>
    </Preview>
  </div>
</template>
<script>
import Preview from './Preview.vue';
import PreviewControl from './PreviewControl.vue';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Viewer',
  components: {
    PreviewControl,
    Preview,
  },
  props: {
    file: {
      type: [String, Uint8Array],
      default: null,
    },
    fileName: {
      type: String,
      default: '',
    },
    mailFrom: {
      type: String,
      default: '',
    },
    mailSubject: {
      type: String,
      default: '',
    },
    mailDate: {
      type: String,
      default: new Date().toString(),
    },
  },
  data() {
    return {
      numPages: 1,
      page: 1,
      rotate: 0,
      refreshCanvasSize: 0,
    };
  },
  watch: {
    file() {
      this.page = 1;
    },
    page(value) {
      this.$emit('current-page', value);
    },
    numPages(value) {
      this.$emit('num-pages', value);
    },
  },
};
</script>

<style scoped></style>
